import Const from 'constants';

const LimitOnePitcherPerGame = {
    setLimitOnePitcherPerGameFromStorage(value) {
        return (dispatch) => {
            dispatch(this.setLimitOnePitcherPerGame(value, {saveToStorage: false}));
        };
    },

    setLimitOnePitcherPerGame(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_LIMIT_ONE_PITCHER_PER_GAME,
                limitOnePitcherPerGame: Boolean(value),
                });

            saveToStorage && dispatch(
                this.saveDataToStorage('limitOnePitcherPerGame', function (state) {
                    const {filters} = state.lineupsData;

                    return filters.limitOnePitcherPerGame;
                }),
            );
        };
    },
};

export default LimitOnePitcherPerGame;
